import { render, staticRenderFns } from "./Kink.vue?vue&type=template&id=7b6b77da&scoped=true&"
import script from "./Kink.vue?vue&type=script&lang=ts&"
export * from "./Kink.vue?vue&type=script&lang=ts&"
import style0 from "./Kink.vue?vue&type=style&index=0&id=7b6b77da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6b77da",
  null
  
)

export default component.exports